import { FC } from 'react';

import s from '../SystemDocumentation.module.scss';
import { Input } from '@ews/react-data';
import { useL10n } from '@ews/react-localization-context';

const TableInputs: FC<{ data: Input[]; }> = ({
    data
}) =>
{
    const { translate: t } = useL10n();

    if (!data) return <>{t("[REACT_NO_DATA]")}</>;
    return <table id='system-documentation-inputs' data-name='Eingänge' className={s.table}>
        <thead>
            <tr>
                <td style={{ width: "290px" }}></td>
                <td style={{ width: "290px" }}></td>
                <td style={{ width: "290px" }}></td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={2}>{t("[REACT_FIRE_ALARM_SYSTEM]")}</td>
                <td className={`${s.b} ${s.title}`} colSpan={3}>{t("[REACT_TRVB_123_S]")}</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={2}>Eingänge (technische Alarme)</td>
                <td className={`${s.bR} ${s.title}`} colSpan={3}>{t("[REACT_ANHANG_1]")}</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bR} ${s.title}`} colSpan={3}>{t("[REACT_EGV_1]")}</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_EINGANGS_NR_]")}</td>
                <td className={`${s.b} ${s.aC} ${s.tL}`}>Bezeichnung/Ort</td>
                <td className={`${s.b} ${s.aC} ${s.tL}`}>angesteuert von Gerät</td>
            </tr>

            {data.map((item, idx) =>
                'to' in item ? (
                    <tr className={`${s.doubleHeight} ${s.greyRow}`}>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>
                            {item.from + ' bis ' + item.to}
                        </td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}></td>
                    </tr>) : (
                    <tr key={idx}>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.inputNumber}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.description}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.controlledByDevice}</td>
                    </tr>

                )
            )}
        </tbody>
    </table>;
};

export default TableInputs;
